import iconComponents from '@/assets/icons/iconComponents'
import Button from '@/common/button'
import FormGroup from '@/common/Input/FormGroup'
import InputWithAdornment from '@/common/Input/InputWithAdornment'
import { ToastNotify } from '@/common/toastManager'
import Typography from '@/common/Typography'
import { withAsync } from '@/helpers/withAsync'
import { useRecoverPasswordMutation } from '@/store/authSlice'
import { ChangeEvent, FormEvent, useState } from 'react'
import { useNavigate, useParams } from 'react-router'

const AdminRecoverPassword = () => {
  const { code } = useParams()
  const [passwords, setPasswords] = useState({
    new_password: '',
    verify_password: '',
  })

  const navigate = useNavigate()
  const [recoverPassword, { isLoading: isSending }] =
    useRecoverPasswordMutation()
  const submitHandler = async (e: FormEvent) => {
    e.preventDefault()
    if (
      passwords.new_password !== passwords.verify_password ||
      !passwords.new_password.trim()
    ) {
      return ToastNotify('warn', {
        message: 'Password does not match',
      })
    }
    const { error } = await withAsync(() =>
      recoverPassword({
        code: code as string,
        new_password: passwords.new_password,
      })
    )
    if (error) {
      return ToastNotify('error', {
        message: (error as any)?.message || 'Ooops try again.',
      })
    }
    ToastNotify('success', {
      message: 'Password has been changed Successfully',
    })
  }
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name, value },
    } = e
    setPasswords((prev) => ({ ...prev, [name]: value }))
  }

  return (
    <div className='px-4 w-full flex flex-col gap-6 sm:gap-10 justify-start items-center sm:px-[19%] mb-12'>
      <div className='w-[72px] h-[72px] bg-jaa-teal-20 border-[10.833px] border-[#E8F6F8] rounded-full sm:w-[96px] sm:h-[96px] flex justify-center items-center'>
        <iconComponents.util.UnlockIcon
          stroke='var(--teal-100)'
          className='w-[28px] h-[31px] sm:w-8 sm:h-h-9'
        />
      </div>
      <header className='flex flex-col gap-1 w-full self-start'>
        <Typography as='h2' className='h3 text-jaa-shades-black  sm:h2'>
          Reset Your Password
        </Typography>
        <Typography as='p' className='text-jaa-shades-gray-2.5 font-normal sm'>
          Choose a new password here, then log in to your account.
        </Typography>
      </header>
      <form
        onSubmit={submitHandler}
        className='flex flex-col w-full justify-center items-center gap-4'
      >
        <FormGroup id='new_password' label='New Password'>
          <InputWithAdornment
            name='new_password'
            type='password'
            value={passwords.new_password}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup id='verify_password' label='Verify Password'>
          <InputWithAdornment
            name='verify_password'
            type='password'
            value={passwords.verify_password}
            onChange={handleChange}
          />
        </FormGroup>
        <Button
          disabled={isSending}
          loading={isSending}
          type='submit'
          label='reset password'
          className='w-full lg:w-1/2 capitalize'
        />
        <Typography as='p' className='sm text-jaa-shades-black'>
          Changing your password logs you out of all browsers on your
          devices(s).
        </Typography>
      </form>
      <Button
        disabled={isSending}
        onClick={() => navigate('/admin/auth/sign-in')}
        variant='empty'
        label={
          <span className='flex justify-center items-center gap-2 text-jaa-shades-gray-3 md font-normal'>
            <iconComponents.util.ArrowLeftIcon
              strokeWidth={'1'}
              stroke='var(--shades-gray-3)'
            />
            <span>Back to log in </span>
          </span>
        }
      />
    </div>
  )
}

export default AdminRecoverPassword
